import { useState } from "react"
import { useLocation } from "react-router-dom"
import AddUniLabExperiment from "./AddUniLabExperiment"

const AddLabPrototype = () => {
  const location=useLocation()
  const {university_id,department_id,lab_id,group_id}=location?.state
  const [count,setCount]=useState(0)
   const handleClick = () => {
    console.log("Child button clicked");
  };
console.log("Parent render", handleClick);
  return (
    <div className="flex flex-col">
      Add Lab Prototype {university_id} {department_id} {lab_id} {group_id}
      {count}
      <button onClick={() => setCount(count + 1)}>
        Increase Count
      </button>

      <AddUniLabExperiment onClick={handleClick}/>
    </div>
  )
}

export default AddLabPrototype
